/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ xp: NonNullable<unknown>, days: NonNullable<unknown>, n: NonNullable<unknown> }} Leveling_Reward_ActivityInputs */



/**
* | output |
* | --- |
* | "{xp} XP in {days} days" |
*
* @param {Leveling_Reward_ActivityInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_activity = /** @type {((inputs: Leveling_Reward_ActivityInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_ActivityInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`${i?.xp} XP за ${i?.days} день`);
		if (form === "few") return /** @type {LocalizedString} */ (`${i?.xp} XP за ${i?.days} дня`);
		if (form === "many") return /** @type {LocalizedString} */ (`${i?.xp} XP за ${i?.days} дней`);
		return /** @type {LocalizedString} */ (`${i?.xp} XP за ${i?.days} дня`)
	}
	return /** @type {LocalizedString} */ (`${i?.xp} XP in ${i?.days} days`)
});